<template>
  <Html lang="en">

    <Head>
      <Title>{{ title }}</Title>
    </Head>

    <Body>
      <NuxtLoadingIndicator :color="'#fed400'" :height="4" />
      <div :data-theme="theme">
        <slot />
      </div>
    </Body>
  </Html>
</template>

<script setup>
const route = useRoute();
const title = computed(() => t('Cantas.id', { title: t(route.meta.title ?? 'TBD') }));

// const THEMES = [
//   'light',
//   'dark',
// ];
const theme = ref(null);
const isLoading = ref(true);
watch(theme, (value) => {
  localStorage.setItem('daisyui-theme', value);
});
onMounted(() => {
  theme.value = localStorage.getItem('daisyui-theme') || 'light';
});
</script>
